 $(document).ready(function() {
       $('body').on('change', '.form_modal_popup .swatch_checkbox', function() {
        var selectedValues = [];
        var ariaLabel = $(this).closest('.hulkapps_option').find('.hulkapps_option_name').attr('aria-label');

         setTimeout(()=>{
           
        $(this).closest('.hulkapps_option').find('.hulk_po_checkbox.swatch_selected').each(function() {
            selectedValues.push($(this).find('.swatch_checkbox').val() || ''); // Ensure to push an empty string if the value is not present
        });
    
        var selectedString = selectedValues.join(', ');
    
        $('.hulkPO_hidden input[name="properties[' + ariaLabel.trim() + ']"]').val(selectedString);
         },100)

         setTimeout(function(){
            var checkedCount = $('.form_modal_popup').find('.hulkapps_option_set div.swatch_selected').length;
            console.log("checkedCount form_modal", checkedCount);
            if (checkedCount > 8) {
                $(this).prop('checked', false);
               
            } else {
                $('.form_modal_popup .hulk_po_swatch_multiple_checkbox').prop('disabled', false);
               
                $('.form_modal_popup .hulkapps_mswatch_option').removeClass('disabled'); // Remove disabled class from parent div
             }

            if (checkedCount === 8) {
                $('.form_modal_popup .hulk_po_swatch_multiple_checkbox:not(:checked)').prop('disabled', true);
             
                $('.form_modal_popup .hulk_po_swatch_multiple_checkbox:not(:checked)').parents('.hulkapps_mswatch_option').addClass('disabled'); // Add disabled class to parent div
             }
        }, 800);
           
    });
   
    $(".required").on("input", function() {
        $(this).val() !== "" && $(this).removeClass("invalid")
    });


   function submitForm() {
    var requestData = {};
    var addressData = {}; // Object to hold address fields

    // Iterate over the form data and create the requestData object
    $('.form_generater_form_div_custom input, .form_generater_form_div_custom textarea').each(function() {
        var fieldType = $(this).attr('type');
        var fieldName = $(this).attr('name');
        var fieldValue = $(this).val();

        // Check if the field is an address field
        if (fieldName == 'Address line 1' || fieldName == 'Address line 2' || fieldName == 'City' || fieldName == 'Province' || fieldName == 'Zip code' || fieldName == 'Country') {
            // Include the address field in the addressData object
            addressData[fieldName] = fieldValue;
        } else {
            // Include other fields in the requestData object
            // Check if the field is a checkbox or radio button
            if (fieldType === 'checkbox') {
                // Only include the field if it is checked
                if ($(this).is(':checked')) {
                    requestData[fieldName] = fieldValue;
                }
            } else if (fieldType === 'radio') {
                // Only include the field if it is checked
                if ($(this).is(':checked')) {
                    requestData[fieldName] = fieldValue;
                }
            } else if (fieldType === 'hidden') {
                // Only include the field if it is checked
                if (fieldValue.trim() !== '') {
                    requestData[fieldName] = fieldValue;
                }
            }
            else {
                // Include the field if it is not empty
                if (fieldValue.trim() !== '') {
                    requestData[fieldName] = fieldValue;
                }
            }
        }
    });

    // Include the addressData object in the requestData object
    requestData['Address'] = [addressData];

    console.log("requestData", requestData);

    // Convert the data object to a JSON string
    var jsonData = JSON.stringify({ formResponse: requestData });
    console.log("jsonData", jsonData);

    // Make an AJAX POST request to submit the form data
    $.ajax({
        type: "POST",
        url: "https://formbuilder.hulkapps.com/forms/create_response/6y8F6GkA1yXQ6nTsiPysDg",
        headers: {
            "X-Form-Access-Token": "fe810843d97b7d13",
            "Content-Type": "application/json",
            "accept": "application/json"
        },
        data: jsonData,
        success: function(responses) {
            // Handle the response here
            console.log("Response:", responses);
        },
        error: function(error) {
            // Handle errors here
            console.error("Error:", error);
        }
    });

    // Clear form fields and remove validation after 3 seconds
    setTimeout(function() {
        clearFormFields();
        $('input[type="checkbox"]').closest('.checkbox-multi').removeClass('invalid');
        $('.required[name="Email"]').removeClass('invalid-email');
        $('.invalidEmail').remove();
    }, 3000);
}

    function clearFormFields() {
        $(".form_generater_form_div_custom")[0].reset()
       setTimeout(function() {
            $('body').find('.closeFBpopup').trigger('click');
            $('body').find('.closeFBpopup').click();
         
        }, 800)
     
    }
    $("body").on("click", ".submitForm_hablemos", function(event) {
        event.preventDefault(), $(".submitForm_hablemos").text("Submited"); 
          submitForm();
          setTimeout(function() {
            $(".submitForm_hablemos").text("Submit");
        }, 800)
    })



});